import { Fragment } from "react";
import React, { useState, useCallback, useEffect } from 'react';
import ReactDom from 'react-dom';
import $i18n from '@cainiaofe/panda-i18n-lite';
import { errorLevelIconEnum } from "../const";
import "./style.scss";
export default {
  show: function show(infoConfig) {
    if (infoConfig === void 0) {
      infoConfig = {};
    }
    if (!window.CNUI || !window.CNUI.CnDialog) {
      console.error('CnErrorFeedback: CNUI is not defined, please import CNUI first');
      return;
    }
    var _ref = window.CNUI || {},
      CnDialog = _ref.CnDialog,
      CnMessage = _ref.CnMessage,
      CnDrawer = _ref.CnDrawer,
      CnButton = _ref.CnButton,
      CnIcon = _ref.CnIcon;
    var Dialog = function Dialog(_ref2) {
      var _ref2$infoConfig = _ref2.infoConfig,
        infoConfig = _ref2$infoConfig === void 0 ? {} : _ref2$infoConfig,
        onClose = _ref2.onClose;
      var _infoConfig$errorCont = infoConfig.errorContentInfo,
        _infoConfig$errorCont2 = _infoConfig$errorCont === void 0 ? {} : _infoConfig$errorCont,
        errorTitle = _infoConfig$errorCont2.errorTitle,
        errorLevel = _infoConfig$errorCont2.errorLevel,
        confirmTexts = _infoConfig$errorCont2.confirmTexts,
        confirmUrl = _infoConfig$errorCont2.confirmUrl,
        _infoConfig$errorSolu = infoConfig.errorSolution,
        _infoConfig$errorSolu2 = _infoConfig$errorSolu === void 0 ? {} : _infoConfig$errorSolu,
        enableSolution = _infoConfig$errorSolu2.enableSolution,
        solutionType = _infoConfig$errorSolu2.solutionType,
        textReason = _infoConfig$errorSolu2.textReason,
        textSolution = _infoConfig$errorSolu2.textSolution,
        text = _infoConfig$errorSolu2.text,
        manualUrl = _infoConfig$errorSolu2.manualUrl,
        errorMsg = infoConfig.errorMsg,
        errorCode = infoConfig.errorCode;
      var _useState = useState(false),
        visible = _useState[0],
        setVisible = _useState[1];
      var _useState2 = useState(false),
        fl = _useState2[0],
        setFl = _useState2[1];
      var _useState3 = useState(true),
        dialogVisible = _useState3[0],
        setDialogVisible = _useState3[1];
      var _useState4 = useState(),
        feedbackIcon = _useState4[0],
        setFeedbackIcon = _useState4[1];
      var _useState5 = useState(false),
        hasFeedback = _useState5[0],
        setHasFeedback = _useState5[1];
      var iframeFinal = function iframeFinal() {
        return !fl && (setFl(true), setVisible(false));
      };
      useEffect(function () {
        setTimeout(function () {
          return setVisible(enableSolution && solutionType === 'iframe');
        });
      }, []);
      var closeDrawer = useCallback(function () {
        setVisible(false);
      }, []);
      var feedbackAction = function feedbackAction(type) {
        try {
          var _window, _window$trace, _window2, _window2$trace;
          if (hasFeedback) return;
          ((_window = window) === null || _window === void 0 ? void 0 : (_window$trace = _window.trace) === null || _window$trace === void 0 ? void 0 : _window$trace.logCustom) && ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$trace = _window2.trace) === null || _window2$trace === void 0 ? void 0 : _window2$trace.logCustom({
            p1: 'errorCodeFeedback',
            c8: errorMsg,
            c9: errorCode,
            c10: type
          }));
          setFeedbackIcon(type);
          setHasFeedback(true);
          CnMessage.show($i18n.get({
            id: 'ThankYouForYourFeedback',
            dm: '谢谢您的反馈！'
          }));
        } catch (error) {}
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CnDialog, {
        className: "cn-error-feedback-dialog",
        visible: dialogVisible,
        okProps: {
          children: confirmTexts,
          visible: !!confirmTexts
        },
        onOk: function onOk(_) {
          confirmUrl && window.open(confirmUrl);
          setDialogVisible(false);
        },
        afterClose: onClose,
        onClose: function onClose(_) {
          return setDialogVisible(false);
        },
        onCancel: function onCancel(_) {
          return setDialogVisible(false);
        },
        footer: /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            alignItem: 'center',
            marginTop: 6
          }
        }, /*#__PURE__*/React.createElement("span", null, $i18n.get({
          id: 'IsItHelpful',
          dm: '是否有帮助'
        })), /*#__PURE__*/React.createElement(CnIcon, {
          onClick: feedbackAction.bind(null, 'good'),
          style: {
            margin: '0 16px',
            cursor: 'pointer'
          },
          type: feedbackIcon === 'good' ? 'icon-good-fill' : 'icon-good'
        }), /*#__PURE__*/React.createElement(CnIcon, {
          onClick: feedbackAction.bind(null, 'bad'),
          style: {
            rotate: '180deg',
            cursor: 'pointer'
          },
          type: feedbackIcon === 'bad' ? 'icon-good-fill' : 'icon-good'
        }))
      }, /*#__PURE__*/React.createElement("div", {
        className: "error-message-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title",
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(CnIcon, {
        type: errorLevelIconEnum[errorLevel].icon,
        size: "xl",
        style: {
          color: errorLevelIconEnum[errorLevel].color
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 18,
          color: '#333',
          fontWeight: 500,
          marginLeft: 4
        }
      }, errorTitle)), /*#__PURE__*/React.createElement("div", {
        className: "content",
        style: {
          color: '#333',
          fontSize: 12,
          lineHeight: '18px',
          marginTop: 16,
          paddingLeft: 28
        }
      }, /*#__PURE__*/React.createElement("p", null, errorMsg), enableSolution && solutionType && (solutionType === 'text' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, textReason), /*#__PURE__*/React.createElement("p", null, textSolution)) : /*#__PURE__*/React.createElement(CnButton, {
        type: "primary",
        text: true,
        onClick: function onClick(_) {
          solutionType === 'hyperlink' ? window.open(manualUrl) : (setVisible(true), setFl(true));
        }
      }, text))))), /*#__PURE__*/React.createElement(CnDrawer, {
        visible: visible,
        popupContainer: document.body,
        title: $i18n.get({
          id: 'Solution',
          dm: '解决方案'
        }),
        size: "large",
        footer: true,
        style: {
          display: fl ? 'block' : 'none'
        },
        hasMask: fl,
        okProps: {
          visible: false
        },
        cache: true,
        onOk: closeDrawer,
        onClose: closeDrawer,
        onCancel: closeDrawer
      }, manualUrl && /*#__PURE__*/React.createElement("iframe", {
        onError: iframeFinal,
        onLoad: iframeFinal,
        style: {
          border: 'none',
          height: '83vh'
        },
        width: "100%",
        src: manualUrl
      })));
    };
    var _infoConfig = infoConfig,
      _infoConfig$errorCont3 = _infoConfig.errorContentInfo,
      _infoConfig$errorCont4 = _infoConfig$errorCont3 === void 0 ? {} : _infoConfig$errorCont3,
      displayMode = _infoConfig$errorCont4.displayMode,
      errorTitle = _infoConfig$errorCont4.errorTitle,
      errorLevel = _infoConfig$errorCont4.errorLevel,
      errorMsg = _infoConfig.errorMsg;
    switch (displayMode) {
      case 'dialog':
        var div = document.createElement('div');
        var unmount = function unmount() {
          var _div$parentNode;
          ReactDom.unmountComponentAtNode(div);
          (_div$parentNode = div.parentNode) === null || _div$parentNode === void 0 ? void 0 : _div$parentNode.removeChild(div);
        };
        document.body.append(div);
        ReactDom.render( /*#__PURE__*/React.createElement(Dialog, {
          infoConfig: infoConfig,
          onClose: unmount
        }), div);
        return {
          close: unmount
        };
      case 'tips':
        CnMessage[errorLevel]({
          title: errorTitle,
          content: errorMsg
        });
        return {
          close: CnMessage.hide
        };
      default:
    }
  }
};